import { Button, Dialog, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import { useState } from "react";
import DialogButtons from "@entrilia/shared/components/DialogButtons";
import DialogCloseButton from "@entrilia/shared/components/DialogCloseButton";
import type { Contact } from "../../../../../api/types/fundStructureTypes";
import MultiselectAutocomplete from "../../../../common/MultiselectAutocomplete";

interface Props {
  open: boolean;
  options: Contact[];
  title: string;
  description: string;
  onClose: () => void;
  onCreateNew: () => void;
  onContactsSelected: (contacts: Contact[]) => void;
}

const AssignInvestorContactDialog = ({
  open,
  options,
  title,
  description,
  onClose,
  onCreateNew,
  onContactsSelected,
}: Props) => {
  const [selectedContacts, setSelectedContacts] = useState<Contact[]>([]);

  const handleAddContacts = () => {
    onContactsSelected(selectedContacts);
    setSelectedContacts([]);
  };

  const handleDialogClose = () => {
    setSelectedContacts([]);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleDialogClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogCloseButton onClick={handleDialogClose} />
      <DialogContent>
        <Stack spacing={2}>
          <Typography color="textSecondary">{description}</Typography>
          <MultiselectAutocomplete
            options={options}
            values={selectedContacts}
            onSelected={setSelectedContacts}
            getOptionLabel={(option: Contact) => option.name}
            getOptionValue={(option: Contact) => option.id}
            getOptionDescription={(option: Contact) => option.email}
            noItemsText="No contacts"
            onCreateOption={onCreateNew}
          />
        </Stack>
      </DialogContent>
      <DialogButtons onCancel={handleDialogClose}>
        <Button disabled={selectedContacts.length === 0} onClick={handleAddContacts} variant="contained">
          Add Contact(s)
        </Button>
      </DialogButtons>
    </Dialog>
  );
};

export default AssignInvestorContactDialog;
